import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import classNames from 'classnames';
import * as React from 'react';
import { Collapse } from '@wix/package-picker-components';
import { Experiments, PaymentCycle, Theme } from 'enums';
import { MonthlyDisclaimer } from '../MonthlyDisclaimer/MonthlyDisclaimer';
import { AscendBundleHelper } from './AscendBundleHelper';
import s from './Cycles.scss';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { RootStore, withInjectedRootStore } from 'providers';
import { RevShareHelper } from './RevShareHelper/RevShareHelper';
import { CycleDetails } from 'types';
interface CycleHelperProps extends InjectedExperimentsProps {
  cycle: CycleDetails;
  _disclaimerKey: string;
  isAscendBundle: boolean;
  features: any;
  showDisclaimer: boolean;
  isShown: boolean;
  rootStore: RootStore;
}

const CycleHelperComp: React.FC<CycleHelperProps> = ({
  cycle,
  isAscendBundle,
  features,
  showDisclaimer,
  isShown,
  experiments,
  rootStore,
}) => {
  const { theme } = usePageModeContext();
  const { cycleId } = cycle;
  const isAscendBundleEnabeled = experiments.enabled(Experiments.AscendBundle);
  const { isEligibleForRevShare } = rootStore.appStore;
  let helperToRender: React.ReactNode = null;
  if (theme === Theme.Dayful) {
    return null;
  }
  if (isEligibleForRevShare) {
    helperToRender = <RevShareHelper cycle={cycle} />;
  }
  else {
    if (PaymentCycle.YEARLY.includes(cycleId)) {
      return null;
    }
    if ([PaymentCycle.YEAR2, PaymentCycle.YEAR3].includes(cycleId)) {
      if (isAscendBundleEnabeled && isAscendBundle) {
        helperToRender = <AscendBundleHelper />;
      } else {
        return null;
      }
    }
  }

  if (PaymentCycle.MONTHLY.includes(cycleId) && showDisclaimer) {
    helperToRender = <MonthlyDisclaimer missingFeatureList={features} />;
  }

  if (helperToRender === null) {
    return null;
  }

  return (
    <Collapse
      isOpened={isShown}
      initialStyling={{
        width: '100%',
      }}
    >
      <div className={classNames(s.cycleHelper, { [s.withPadding]: isShown })}>
        {helperToRender}
      </div>
    </Collapse>
  );
};

export const CycleHelper = withExperiments(withInjectedRootStore(CycleHelperComp));
